import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { IResult } from 'app/shared/models/result.model';
import { Subject } from 'rxjs';
import { AppConfig } from 'app/app.config';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IDtoEmployeeSalaryHistory } from 'app/shared/models/employee/dto-employee-salary-history.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { IDtoEmail } from 'app/shared/models/dto-email.model';
import { EmailService } from 'app/views/appviews/email.service';
import { EnumMovementType } from 'app/shared/enums/budget-movement-type.enum';

@Component({
    selector: 'app-modal-salary-format',
    styleUrls: ['./modal-salary-format.style.scss'],
    templateUrl: './modal-salary-format.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalSalaryFormatComponet implements OnInit {
    /**Variable de trasporte de datos */
    private errorMessages: any;
    private result: IResult;
    private employeeId: number;
    private email: string;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Listas */
    private salaryHistories = new Array() as IDtoEmployeeSalaryHistory[];
    constructor(private bsModalRef: BsModalRef
        , private employeeService: EmployeeService
        , private configGeneral: AppConfig
        , private identityService: IdentityService
        , private spinner: NgxSpinnerService
        , private emailService: EmailService) {
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.getEmployeeSalaryHistories();
    }
    private getEmployeeSalaryHistories(): void {
        this.employeeService.getEmployeeSalaryHistoriesbyEmployeeId(this.employeeId)
            .subscribe(
                (x) => {
                    this.salaryHistories = x.data as IDtoEmployeeSalaryHistory[];
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private downloadFile(item: IDtoEmployeeSalaryHistory): void {
        this.spinner.show();
        this.employeeService.downloadFileEmployeeSalaryUpdate(item.id).subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, file.fileDownloadName);
                this.spinner.hide();
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }
            
        },
        (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
    private sentFormatUpdateSalary(item: IDtoEmployeeSalaryHistory): void {
        this.spinner.show();
        let message = '';
        let email = {} as IDtoEmail;
        switch (item.movementType) {
            case EnumMovementType.Contratacion:
                message = `<strong>Estimado Colaborador (a)</strong><p>A continuación se adjunta el formato de Ajuste de salario donde se desglosa tu salario el cual es de ${item.dailySalary}, favor de revisar, firmar y entregar a tu jefe directo ó coordinador de marca.</p><p>Si tiene alguna duda con respecto a su propuesta favor de revisarlo con recursos humanos.</p>`;
                break;
            case EnumMovementType.Reubicacion:
            case EnumMovementType.Salario:
                message = `<strong>Estimado Colaborador (a)</strong><p>A continuación se adjunta el formato de Ajuste de salario donde se desglosa tu salario el cual es de ${item.salaryAdjust}, favor de revisar, firmar y entregar a tu jefe directo ó coordinador de marca.</p><p>Si tiene alguna duda con respecto a su propuesta favor de revisarlo con recursos humanos.</p>`;
                break;
        }

        email.fromSubject = 'Redpromex';
        email.userId = null;
        email.subject = 'Propuesta Salarial';
        email.toRol = 'Usuario';
        email.message = message;
        email.usedRecord = item.id;
        email.to = this.email;
        email.template = 'update_salary_format';
        this.emailService.sendEmail(email).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
        (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'RiskPremiums';
        dto.module = 'companies';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
